import type { MetricDatum } from '@aws-sdk/client-cloudwatch';
import Metrics, { OutgoingRequestMetricOptions } from '../../../../server/Metrics';

export default class StubMetrics implements Metrics {
    pushRequestMetric(opts: { endpoint: string; statusCode: number; bytes: number; serviceTime: number }) {
        // Do not push request metric.
    }

    pushOutgoingRequestMetric(opts: OutgoingRequestMetricOptions): void {
        // Do not push outgoing request metric
    }

    pushCustomMetric(metricName: string, value: number) {
        // Nothing.
    }

    pushMetrics(metricData: MetricDatum[]) {
        // Do not push metrics.
    }

    flush() {
        // Do not flush.
    }
}
